module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/metavers-481dae7ed2803b82ec57ae203c4c7970.png";